<template>
	<div v-if="renderableItems.length" class="pointer-events-none space-y-2" :class="{'grayscale': isInStock(product) === false}">
		<ProductRibbon
			v-for="(item, index) in renderableItems"
			:key="`item.ribbon.type-${index}`"
			:ribbon="item.ribbon"
			:v-help-price="item.vHelpPrice"
			:is-product-detail="isProductDetail"
			class="flex relative items-start"
		/>
	</div>
</template>

<script setup lang="ts">
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
	import {Ribbon, type RenderableItem} from '@/types/product';
	import {RIBBON_VHELP_CLUB_ID} from '#shared/constants';
	import {isInStock} from '~/utils';

	type Props = {
		product: ProductDetail;
		isProductDetail?: boolean;
	};

	const props = defineProps<Props>();

	const supportedImageRibbons = [
		Ribbon.vVVGButchery,
		Ribbon.vVVGBakery,
		Ribbon.vVVGRestaurant,
	];

	const renderableItems = computed<RenderableItem[]>(() => {
		const ribbons = extractProductRibbons(props.product);

		return ribbons.flatMap((ribbon) => {
			if (ribbon.type === Ribbon.COUPON || supportedImageRibbons.includes(ribbon.type)) {
				return [{ribbon}];
			}

			if (ribbon.type === Ribbon.vHelp) {
				const price = props.product.productInHouse?.customerClubDiscounts?.find(
					(discount) => discount.customerClub === RIBBON_VHELP_CLUB_ID,
				)?.discount;

				if (price) {
					return [{ribbon, vHelpPrice: price}];
				}
			}

			return [];
		});
	});
</script>
